import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { UIRouter, Transition } from "@uirouter/angular";


@Component({
  selector: '[mailbox-email]',
  templateUrl: './mailbox-email.component.html',
  styleUrls: ['../mailbox/mailbox.component.less']
})


export class MailboxEmailComponent {


	private isCollapsedOne:boolean
	@Input() 
  email:any;
  @Output() 
  mailboxEmailEvent: EventEmitter<any> = new EventEmitter();
  unreadClass:string


  constructor(private apiService : ApiService, private router: UIRouter) { 
  	this.isCollapsedOne = true
  }

  ngOnInit() {
  }


}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/app/mailbox-email/mailbox-email.component.ts